import { Badge } from "../lib/ui";

export default function ConformancePanel({ app, testId = "engineering-conformance" }) {
  const eng = app?.engineering_conformance;
  const adr = app?.adr;
  if (!eng && !adr) return null;

  return (
    <section className="feature-panel conformance-panel" data-testid={testId}>
      <div className="panel-header compact">
        <h2>Architecture & engineering path</h2>
        <Badge tone="slate">Lean derived</Badge>
      </div>
      {adr && (
        <div className="conformance-block" data-testid="adr-stub">
          <p className="kicker">ADR · AFTER G3</p>
          <strong>{adr.title || adr.note || "Pending G3"}</strong>
          {adr.decision && <p className="muted small-note">{adr.decision} — {adr.rationale}</p>}
        </div>
      )}
      {eng && (
        <div className="conformance-block" data-testid="eng-rules">
          <p className="kicker">ENGINEERING CONFORMANCE · {eng.strategy}</p>
          <ul className="conformance-list">
            {(eng.rules || []).map((rule) => <li key={rule}>{rule}</li>)}
          </ul>
          <p className="kicker">TEST CATEGORIES</p>
          <div className="conformance-tests">
            {(eng.test_categories || []).map((t) => (
              <span key={t.id} title={t.note}>{t.label}</span>
            ))}
          </div>
          <p className="muted small-note">{eng.note}</p>
        </div>
      )}
    </section>
  );
}
